export const NOTIFY_RECIPIENTS_MODAL_TEST_ID = 'modal.notifyRecipients'

export const NOTIFY_RECIPIENTS_COPY = {
  button: 'Notify recipients',
  title: 'Notify recipients',
  body: 'The recipients you select will be emailed a link to this quote. Signers will also be asked to sign it.',
  recipientsLabel: 'Recipients',
  messageLabel: 'Message (optional)',
  messagePlaceholder: 'Add message',
  submitButton: 'Send',
  submittingButton: 'Sending...',
  successToast: 'Recipients notified',
  errorToast: 'Failed to notify recipients'
} as const
